import React, { ReactElement } from "react";
import { Dropdown } from "react-bootstrap";
import { RiSendPlaneLine } from "@remixicon/react";
import { TicketItem } from "../../../contexts/ticket-state";

interface SendNowMessageActionProps {
    iconOnly?: boolean;
    ticketMessageId: string;
    ticketItem?: TicketItem;
}

export default function SendNowMessageAction({
    iconOnly, ticketMessageId, ticketItem,
}: SendNowMessageActionProps): ReactElement {
    const onDeliver = () => {
        ticketItem?.deliverScheduledMessage(ticketMessageId);
    };

    return (
        <Dropdown.Item onClick={() => onDeliver()} title={iconOnly ? "Send Now" : undefined}>
            {iconOnly ? <RiSendPlaneLine /> : "Send Now"}
        </Dropdown.Item>
    );
}

SendNowMessageAction.defaultProps = {
    iconOnly: false,
    ticketItem: undefined,
};
